import {error_handler, get_bugsnag} from '../../lib/util'
import {api} from '../../lib/api'

export const get_regular_donation = async email => {
  const bugsnag = get_bugsnag()

  bugsnag.leaveBreadcrumb(`get regular donation | ${email}`)

  let regular_donation = null
  const response = await api.get(`/donations?email=${email}`)
  regular_donation = response.data

  return (regular_donation.amount && regular_donation.period)
    ? regular_donation
    : null
}
